module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/columns-filter/columns-filter.component.scss
// module id = ./src/app/shared/columns-filter/columns-filter.component.scss
// module chunks = main